import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Service, ServiceApprovalInput, ServiceInput, ServiceInstitutionFilter} from './service.model';

export const loadServices = createAction(
  '[Service/API] Load Services',
  props<{ services: Service[] }>()
);

export const addService = createAction(
  '[Service/API] Add Service',
  props<{ service: Service }>()
);

export const upsertService = createAction(
  '[Service/API] Upsert Service',
  props<{ service: Service }>()
);

export const addServices = createAction(
  '[Service/API] Add Services',
  props<{ services: Service[] }>()
);

export const upsertServices = createAction(
  '[Service/API] Upsert Services',
  props<{ services: Service[] }>()
);

export const updateService = createAction(
  '[Service/API] Update Service',
  props<{ service: Update<Service> }>()
);

export const updateServices = createAction(
  '[Service/API] Update Services',
  props<{ services: Update<Service>[] }>()
);

export const deleteService = createAction(
  '[Service/API] Delete Service',
  props<{ id: string }>()
);

export const deleteServices = createAction(
  '[Service/API] Delete Services',
  props<{ ids: string[] }>()
);

export const clearServices = createAction(
  '[Service/API] Clear Services'
);


// CUSTOM
export const createService = createAction(
  '[Service/API] create Services',
  props<{ input: ServiceInput }>()
);


export const editService = createAction(
  '[Service/API] edit Service',
  props<{ input: ServiceInput }>()
);


export const removeService = createAction(
  '[Service/API] remove Service',
  props<{ serviceUniqueId: string, id: string }>()
);


export const getAllService = createAction(
  '[Service/API] get all Services',
  props<{ filtering?: ServiceInstitutionFilter }>()
);
export const getNotApprovedServices = createAction(
  '[Service/API] get not approved Services',
  props<{ profileUniqueId: string }>()
);

export const getServiceApprovalRequests = createAction(
  '[Service/API] get Services approval requests',
  props<{ filtering: {
      serviceUniqueId?: string;
      institutionUniqueId?: string;
      categoryUniqueId?: string;
      approvedStatus?: boolean;
      profileUniqueId?: string;
      sectorUniqueId ? : string
      ministryUniqueId? : string,
      isReviewed?: boolean
    } }>()
);

export const getPopsmggApprovalServices = createAction(
  '[Service/API] get Popsmgg approval services',
  props<{ filtering: any }>()
);

export const getServicesAtMyRoster = createAction(
  '[Service/API] get Services at my roster',
  props<{ filtering: any }>()
);


export const serviceApprovalPopsm = createAction(
  '[Service/API] services approval popsm',
  props<{ input?: {
      serviceUniqueId?: string;
      serviceIsApproved?: boolean;
      comment?: string
    } }>()
);

export const serviceReviewPopsm = createAction(
  '[Service/API] services review popsm',
  props<{ input?: { serviceUniqueId?: string}}>()
)

export const submitResubmitServiceApproval = createAction(
  '[Service/API] submit resubmit Services approval',
  props<{ input?: ServiceApprovalInput }>()
);

export const rosterSubmitResubmitServiceApproval = createAction(
  '[Service/API] roster submit resubmit Services approval',
  props<{ input?: ServiceApprovalInput }>()
);
